// extracted by extract-css-chunks-webpack-plugin
module.exports = {"video_box":"video_box-20CradMg","video":"video-RCL6EUFZ","text":"text-3WQItoYa","icon":"icon-2pmkl2vt","icon_2x":"icon_2x-2gL7Xtiu"};